import { logEventInGTAG } from 'src/app/project/services/analytics/google-analytics';
import {
  EGoogleEventCategory,
  EGoogleEventSettings,
} from 'src/app/project/services/analytics/google-analytics.consts';

export function sendImportEvent(fileImport: boolean): void {
  let importMethod = 'site';

  if (fileImport) {
    importMethod = 'file';
  }

  logEventInGTAG(EGoogleEventSettings.SETTINGS__TAGS__IMPORT, {
    source: EGoogleEventCategory.SETTINGS,
    method: importMethod,
  });
}
